import { useTranslation } from "react-i18next";

import styled from "styled-components";

import logo_01 from "../../assets/images/logo_01.svg";
import logo_new from "../../assets/images/logo_new_1.svg";
import miobr_logo from "../../assets/images/minobr_logo.png";
import logo_03 from "../../assets/images/mmc_logo.png";

export default function FooterComponent(props) {
    const { t } = useTranslation();

    return (
        <Wrapper id={"footer"}>
            <InnerPlaceholder>
                <LeftSection>
                    <LeftLogoPlaceholder>
                        <LeftLogo src={logo_new} />
                    </LeftLogoPlaceholder>
                    <LeftTextPlaceholder>
                        <LeftTop style={{}}>
                            <LeftItem style={{ marginRight: 20 }}>
                                <BLabel>{t("atmno256fbs")}</BLabel>
                                <div>
                                    <Link style={{ fontFamily: "'Noto Sans', sans-serif" }}
                                          href={"mailto:info@mst22.ru"}>info@mst22.ru</Link>
                                </div>
                            </LeftItem>
                            <LeftItem>
                                <BLabel>{t("1e717yd5ooy")}</BLabel>
                                <div>
                                    <Link style={{ fontFamily: "'Noto Sans', sans-serif" }}
                                          href={"mailto:support@mst22.ru"}>support@mst22.ru</Link>
                                </div>
                            </LeftItem>
                            {/*<LeftItem>*/}
                            {/*    <BLabel>{t("3mp9q1bxak2")}</BLabel>*/}
                            {/*    <div style={{ marginBottom: 15 }}>8-800-707-71-61</div>*/}
                            {/*</LeftItem>*/}
                            {/*<LeftItem>*/}
                            {/*    <BLabel>FAQ</BLabel>*/}
                            {/*    <div style={{ marginBottom: 15 }}>*/}
                            {/*        <Link href={"/faq.pdf"}>FAQ</Link>*/}
                            {/*    </div>*/}
                            {/*</LeftItem>*/}
                        </LeftTop>
                    </LeftTextPlaceholder>
                </LeftSection>
                <RightSection>
                    <TopRight>
                        <Image src={miobr_logo} />
                        {/*<Image src={logo_01} />*/}
                        <Image src={logo_03} />
                    </TopRight>
                    <BottomRight>{t("l8le4unmosi")}</BottomRight>
                </RightSection>
            </InnerPlaceholder>
        </Wrapper>
    );
}

const LeftTop = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 5px;
  @media (max-width: 1200px) {
    display: block;
    margin-bottom: 20px;
  }
`;

const LeftItem = styled.div`
  margin-bottom: 20px;
  margin-right: 30px;
  @media (max-width: 820px) {
    :last-of-type {
      margin-bottom: 0px;
    }
  }
`;

const Link = styled.a`
  //color: #00a19a;
  color: #02BF89;

`;

const LeftTextPlaceholder = styled.div``;

const LeftLogoPlaceholder = styled.div`
  margin-bottom: 20px;
  @media (max-width: 820px) {
    display: none;
  }
`;

const BLabel = styled.div`
  font-size: 12px;
  opacity: 0.7;
  font-weight: bold;
  font-family: "Noto Sans", sans-serif;
`;

const LeftLogo = styled.img`
  height: 70px;
`;

const InnerPlaceholder = styled.div`
  margin: 0 auto;
  width: 1400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-family: "Noto Sans", sans-serif;
  @media (max-width: 1400px) {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  @media (max-width: 820px) {
    display: block;
    padding: 20px;
    box-sizing: border-box;
  }
`;

const Wrapper = styled.div`
  font-family: "Noto Sans", sans-serif;
  box-sizing: border-box;
  background: #f4f4f4;
  padding-top: 20px;
  padding-bottom: 10px;
  width: 100%;
`;

const Image = styled.img`
  height: 70px;
  margin-left: 20px;
  margin-right: 20px;

  :last-of-type {
    margin-right: 0px;
  }

  @media (max-width: 820px) {
    margin: 0px !important;
    display: inline-block;
  }
`;

const LeftSection = styled.div`
  flex: 1;
  @media (max-width: 820px) {
    display: block;
    text-align: center;
  }
`;

const RightSection = styled.div``;

const TopRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 820px) {
    display: block;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
  }
`;

const BottomRight = styled.div`
  padding: 20px;
  font-family: "Noto Sans", sans-serif;
  margin-top: 20px;
  padding-bottom: 0px;
  opacity: 0.5;
  font-size: 12px;
  text-align: center;
`;
